import { ReactNode } from "react";

import { CardProps as MuiCardProps } from "@mui/material/Card";
import { MenuItemProps } from "@mui/material/MenuItem";
import { ClassNameMap } from "@mui/styles";

import { DashboardButtonProps } from "../Button";
import { InternalClasses } from "../helpers";

export const cardVibeOptions = ["brand", "positive"] as const;
export type CardVibe = (typeof cardVibeOptions)[number];
export type CardVibeHover = `${CardVibe}Hover`;

export type BaseCardClasses =
  | "root"
  | "fullWidth"
  | "noBackgroundOnHover"
  | "image"
  | "header"
  | "headerLeft"
  | "avatar"
  | "title"
  | "subtitle"
  | "content"
  | "footer"
  | "active"
  | "pointer"
  | CardVibe
  | CardVibeHover;
type FooterActionProps = Partial<DashboardButtonProps> & {
  children: string | ReactNode;
  onClick: DashboardButtonProps["onClick"];
};
type HeaderActionProps = { children: string | ReactNode; onClick: MenuItemProps["onClick"] };

export type CardProps = Omit<MuiCardProps, "classes" | "color"> & {
  active?: boolean;
  avatar?: ReactNode;
  classes?: Partial<ClassNameMap<BaseCardClasses>>;
  vibe?: CardVibe;
  footerActions?: FooterActionProps[];
  fullWidth?: boolean;
  headerActions?: HeaderActionProps[];
  imageSrc?: string;
  noHover?: boolean;
  noBackgroundOnHover?: boolean;
  disabled?: boolean;
  subtitle?: string;
  title?: string;
};

export const DEFAULT_CARD_VIBE = "brand";

export type CardSsrProps = CardProps & {
  forwardedRef?: React.Ref<HTMLDivElement>;
};

const PREFIX = "ZeffyCard";
export const zeffyCardClasses: InternalClasses<typeof PREFIX, BaseCardClasses> = {
  root: `${PREFIX}-root`,
  fullWidth: `${PREFIX}-fullWidth`,
  active: `${PREFIX}-active`,
  brand: `${PREFIX}-brand`,
  positive: `${PREFIX}-positive`,
  brandHover: `${PREFIX}-brandHover`,
  positiveHover: `${PREFIX}-positiveHover`,
  noBackgroundOnHover: `${PREFIX}-noBackgroundOnHover`,
  image: `${PREFIX}-image`,
  header: `${PREFIX}-header`,
  headerLeft: `${PREFIX}-headerLeft`,
  avatar: `${PREFIX}-avatar`,
  title: `${PREFIX}-title`,
  subtitle: `${PREFIX}-subtitle`,
  content: `${PREFIX}-content`,
  footer: `${PREFIX}-footer`,
  pointer: `${PREFIX}-pointer`,
};
